import React from 'react';
import type { LegacyTraceData, TraceResult } from '../../services/tracking.service';
import LegacyTracePanel from './LegacyTracePanel';
import { ExceptionsSection, shownExceptions } from './TraceSnapshotPanel';

/**
 * A gwiTrace EXPORT trace in the popup: the booking's active exceptions, then
 * the legacy LYNX layout CSRs know.
 *
 * The import popup has always rendered exceptions first (TraceSnapshotPanel);
 * the export result went straight to `LegacyTracePanel`, which has no such
 * band, so the one line that explains a ticket was invisible exactly where
 * the LC looks. EBKG18962743 (2026-10-15): the trouble ticket said the port
 * had the booking at Bayport, the popup showed no warning and a terminal
 * column reading HOU-BCT, and the LC read the two as a contradiction.
 */
const ExportTracePanel: React.FC<{ result: TraceResult; data: LegacyTraceData }> = ({
  result,
  data,
}) => {
  return (
    <>
      <ExceptionsSection rows={shownExceptions(result)} />
      <LegacyTracePanel data={data} />
    </>
  );
};

export default ExportTracePanel;
